import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as d, createElementBlock as l, normalizeClass as o, createElementVNode as n } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconCodeBlock",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function u(e, t, i, _, f, a) {
  return d(), l("svg", {
    "aria-label": i.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--code-block"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Code Block",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    n("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M2.54 2.04a.5.5 0 0 0-.5.5v6.92a.5.5 0 0 0 .5.5h6.92a.5.5 0 0 0 .5-.5V6.75a.5.5 0 0 1 1 0v2.71a1.5 1.5 0 0 1-1.5 1.5H2.54a1.5 1.5 0 0 1-1.5-1.5V2.54a1.5 1.5 0 0 1 1.5-1.5h.21a.5.5 0 1 1 0 1h-.21Zm4.064-.594a.5.5 0 0 1 0 .707L5.23 3.527 6.604 4.9a.5.5 0 0 1-.707.707L4.17 3.88a.5.5 0 0 1 0-.707l1.727-1.727a.5.5 0 0 1 .707 0Zm1.776 0a.5.5 0 0 1 .707 0l1.727 1.727a.5.5 0 0 1 0 .707L9.087 5.607A.5.5 0 0 1 8.38 4.9l1.374-1.373L8.38 2.153a.5.5 0 0 1 0-.707Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const b = /* @__PURE__ */ s(c, [["render", u]]);
export {
  b as default
};
//# sourceMappingURL=code-block.js.map
